// extracted by mini-css-extract-plugin
export default {"circle":"progresses_circle__peHMV","rectangle":"progresses_rectangle__QPKnZ"};